__turbopack_context__.v({
  "publisherSection": "Publisher-module__gGLR1q__publisherSection",
});
